import React from 'react'
import BaseIcon from './BaseIcon'

function YouTube(props) {
  return (
    <BaseIcon {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <path d="M22.257 9.142c-2.803-.19-9.048-.189-11.846 0C7.379 9.35 7.024 11.181 7 16c.024 4.81.378 6.65 3.412 6.858 2.799.189 9.043.19 11.846 0 3.032-.208 3.389-2.04 3.412-6.858-.025-4.81-.379-6.65-3.413-6.858zm-8.723 9.969v-6.222l6.69 3.105-6.69 3.117z" fill="currentColor" fillRule="nonzero" />
      </g>
    </BaseIcon>
  )
}

YouTube.defaultProps = {
  title: 'Youtube Icon'
}

export default YouTube
